import React from 'react';

import { convertSiteSettingMetadataToAutoFormSchema } from '~src/commonInfra/utils/SiteSettingsSchemaConverter';

import { useSiteSettingsMetadata } from './useSiteSettingsMetadata';

/**
 * Hook to get AutoForm schema for a specific site settings section
 * Transforms the raw metadata into AutoForm-compatible schema
 * 
 * @param sectionName - The name of the section (e.g., 'collections', 'recycleBin')
 * @returns Object with schema, isLoading, and error
 */
export function useSiteSettingsSchema(sectionName: string) {
    const { sectionMetadata, isLoading, error } = useSiteSettingsMetadata(sectionName);

    const schema = React.useMemo(() => {
        if (!sectionMetadata) {
            return undefined;
        }

        const schemas = convertSiteSettingMetadataToAutoFormSchema({ sectionMetadata: [sectionMetadata] });
        return schemas[0];
    }, [sectionMetadata]);

    return {
        schema,
        isLoading,
        error
    };
}

